export const dataAttributes = {
    draggableTarget: 'data-draggable-target',
    draggableSource: 'data-draggable-source',
    id: 'data-id',
    depth: 'data-depth',
};
//# sourceMappingURL=constants.js.map